// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  color: #e9e9e9;
}

h1 {
  margin: 0;
  padding: 0;
}

div {
  padding: 0;
}

hr {
  border-top: 1px solid #666;
}

a {
  color: #ABABAB;
}

.languageSwitch {
  margin-top: 25px;
}

#loginBox {
  padding-top: 50px;
}

.borderWarning {
  border: 2px solid red;
}

#container {
  min-width: 710px;
  overflow-x: hidden;
  overflow-y: auto !important;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-image: url('background.png');
  padding-bottom: 220px;
  box-sizing: border-box;
}

#logoContainer {
  margin-top: 25px;
  margin-bottom: 50px;
}

#legalNotice {
  position: absolute;
  bottom: 50px;
  left: 0;
  width: 100%;
}

.legalNoticeText {
  font-size: 12px;
  line-height: 1.4;
  color: #ccc;
  margin: 0 0 8px;
  text-align: center;
}

.legalNoticeText:last-child {
  margin-bottom: 0;
}

#legalNotice a {
  color: #e9e9e9;
  text-decoration: underline;
}

.pNull {
  padding: 0;
  margin: 0 0 7px;
}

#loginIconContainer {
  margin-right: 10px;
  margin-top: 1px;
}

.rememberMe {
  padding-top: 6px;
}

#tagTop {
  padding-left: 30px;
  font-size: 20pt;
}

#tagLineContainer {
  margin-top: 70px;
  margin-right: 20px;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

#tagMid {
  font-size: 24pt;
}

.tagEnd {
  font-size: 20pt;
}

.tagEndBottom {
  padding-left: 45px;
  white-space: nowrap;
}

/**
app-form-table ::ng-deep #table_loginForm {
    border: 3px solid blue;
}
app-form-table ::ng-deep #table_loginForm tr td {
    border: 2px solid yellow;
}
app-form-table ::ng-deep #table_loginForm tr:first-child td,
app-form-table ::ng-deep #table_loginForm tr:nth-child(2) td {
    display: block;
    border: 1px solid red;
}
*/
app-form-table ::ng-deep #table_loginForm {
  max-width: 325px;
}

app-form-table ::ng-deep #loginForm-0-1-0-tbox_container input,
app-form-table ::ng-deep #loginForm-0-3-0-middle_field div.formInnerDiv,
app-form-table ::ng-deep #loginForm-0-3-0-tbox_container input {
  width: 100%;
  color: black;
}

app-form-table ::ng-deep #loginForm-0-4-0-blank-html-a a {
  color: #CCC;
}

app-form-table ::ng-deep #loginForm-0-4-0-blank-html-a span a:hover {
  color: #EDF2F5;
}

app-form-table ::ng-deep #loginForm-0-5-0-right_text {
  padding-left: 10px;
}

app-form-table ::ng-deep #loginForm-0-5-0-middle_field {
  padding-top: 15px;
}

app-form-table ::ng-deep #loginForm-0-5-1-middle_field {
  padding-top: 10px;
}

app-form-table ::ng-deep #loginForm-0-5-1-submit_button button:hover {
  background-color: #BBB;
}

app-form-table ::ng-deep #loginForm-0-5-1-submit_button button.btn {
  width: 125px;
}

#alert-login * {
  color: #111111;
  font-size: 110%;
}

#alert-login-container {
  font-family: "Montserrat-Bold";
  position: relative;
  z-index: 100002;
  top: 15px;
  min-width: 710px;
  width: 100%;
  margin: auto;
}

#alert-login-box {
  width: calc(66.666666% + 50px);
  font-family: Arial;
  margin: auto;
  background-color: white;
  border: 3px solid #007566;
  border-radius: 5px;
  padding: 5px;
}

div.mpo {
  margin-top: 81px !important;
  margin-right: 20px !important;
  font-size: 20pt;
}

div.mpo p {
  width: 232px;
  margin: auto;
  text-align: left;
  height: 28px;
}`, "",{"version":3,"sources":["webpack://./src/app/app/components/login/login.component.scss"],"names":[],"mappings":"AAEA;EACI,cAAA;AADJ;;AAIA;EACI,SAAA;EACA,UAAA;AADJ;;AAIA;EACI,UAAA;AADJ;;AAIA;EACI,0BAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,iBAAA;AADJ;;AAIA;EACI,qBAAA;AADJ;;AAIA;EACI,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uCAAA;EACA,qBAAA;EACA,sBAAA;AADJ;;AAIA;EACI,gBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;AADJ;;AAIA;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,cAAA;EACA,0BAAA;AADJ;;AAIA;EACI,UAAA;EACA,eAAA;AADJ;;AAIA;EACI,kBAAA;EACA,eAAA;AADJ;;AAKA;EACI,gBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,eAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EAGA,iBAAA;AAFJ;;AAKA;EACI,eAAA;AAFJ;;AAKA;EACI,eAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,mBAAA;AAFJ;;AAKA;;;;;;;;;;;;CAAA;AAcA;EACI,gBAAA;AAHJ;;AAMA;;;EAGI,WAAA;EACA,YAAA;AAHJ;;AAMA;EACI,WAAA;AAHJ;;AAMA;EACI,cAAA;AAHJ;;AAMA;EACI,kBAAA;AAHJ;;AAMA;EACI,iBAAA;AAHJ;;AAMA;EACI,iBAAA;AAHJ;;AAMA;EACI,sBAAA;AAHJ;;AAMA;EACI,YAAA;AAHJ;;AAMA;EACI,cAAA;EACA,eAAA;AAHJ;;AAMA;EACI,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAHJ;;AAMA;EACI,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AAHJ;;AAOA;EACI,2BAAA;EACA,6BAAA;EACA,eAAA;AAJJ;;AAOA;EACI,YAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AAJJ","sourcesContent":["@use \"./../../../../responsive\" as responsive;\n\n* {\n    color: #e9e9e9;\n}\n\nh1 {\n    margin: 0;\n    padding: 0;\n}\n\ndiv {\n    padding: 0;\n}\n\nhr {\n    border-top: 1px solid #666;\n}\n\na {\n    color: #ABABAB\n}\n\n.languageSwitch {\n    margin-top: 25px;\n}\n\n#loginBox {\n    padding-top: 50px;\n}\n\n.borderWarning {\n    border: 2px solid red;\n}\n\n#container {\n    min-width: 710px;\n    overflow-x: hidden;\n    overflow-y: auto !important;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100vh;\n    background-image: url('../../../../assets/login/background.png');\n    padding-bottom: 220px;\n    box-sizing: border-box;\n}\n\n#logoContainer {\n    margin-top: 25px;\n    margin-bottom: 50px;\n}\n\n#legalNotice {\n    position: absolute;\n    bottom: 50px;\n    left: 0;\n    width: 100%;\n}\n\n.legalNoticeText {\n    font-size: 12px;\n    line-height: 1.4;\n    color: #ccc;\n    margin: 0 0 8px;\n    text-align: center;\n}\n\n.legalNoticeText:last-child {\n    margin-bottom: 0;\n}\n\n#legalNotice a {\n    color: #e9e9e9;\n    text-decoration: underline;\n}\n\n.pNull {\n    padding: 0;\n    margin: 0 0 7px;\n}\n\n#loginIconContainer {\n    margin-right: 10px;\n    margin-top: 1px;\n\n}\n\n.rememberMe {\n    padding-top: 6px;\n}\n\n#tagTop {\n    padding-left: 30px;\n    font-size: 20pt;\n}\n\n#tagLineContainer {\n    margin-top: 70px;\n    margin-right: 20px;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n#tagMid {\n    font-size: 24pt;\n}\n\n.tagEnd {\n    font-size: 20pt;\n}\n\n.tagEndBottom {\n    padding-left: 45px;\n    white-space: nowrap;\n}\n\n/**\napp-form-table ::ng-deep #table_loginForm {\n    border: 3px solid blue;\n}\napp-form-table ::ng-deep #table_loginForm tr td {\n    border: 2px solid yellow;\n}\napp-form-table ::ng-deep #table_loginForm tr:first-child td,\napp-form-table ::ng-deep #table_loginForm tr:nth-child(2) td {\n    display: block;\n    border: 1px solid red;\n}\n*/\n\napp-form-table ::ng-deep #table_loginForm {\n    max-width: 325px;\n}\n\napp-form-table ::ng-deep #loginForm-0-1-0-tbox_container input,\napp-form-table ::ng-deep #loginForm-0-3-0-middle_field div.formInnerDiv,\napp-form-table ::ng-deep #loginForm-0-3-0-tbox_container input {\n    width: 100%;\n    color: black;\n}\n\napp-form-table ::ng-deep #loginForm-0-4-0-blank-html-a a {\n    color: #CCC;\n}\n\napp-form-table ::ng-deep #loginForm-0-4-0-blank-html-a span a:hover {\n    color: #EDF2F5;\n}\n\napp-form-table ::ng-deep #loginForm-0-5-0-right_text {\n    padding-left: 10px;\n}\n\napp-form-table ::ng-deep #loginForm-0-5-0-middle_field {\n    padding-top: 15px;\n}\n\napp-form-table ::ng-deep #loginForm-0-5-1-middle_field {\n    padding-top: 10px;\n}\n\napp-form-table ::ng-deep #loginForm-0-5-1-submit_button button:hover {\n    background-color: #BBB;\n}\n\napp-form-table ::ng-deep #loginForm-0-5-1-submit_button button.btn {\n    width: 125px;\n}\n\n#alert-login * {\n    color: #111111;\n    font-size: 110%;\n}\n\n#alert-login-container {\n    font-family:'Montserrat-Bold';\n    position: relative;\n    z-index: 100002;\n    top:15px;\n    min-width: 710px;\n    width: 100%;\n    margin:auto\n}\n\n#alert-login-box {\n    width: calc(66.666666% + 50px);\n    font-family: Arial;\n    margin: auto;\n    background-color: white;\n    border: 3px solid #007566;\n    border-radius: 5px;\n    padding: 5px;\n}\n\n\ndiv.mpo {\n    margin-top: 81px !important;\n    margin-right: 20px !important;\n    font-size: 20pt;\n}\n\ndiv.mpo p {\n    width: 232px;\n    margin: auto;\n    text-align:  left;\n    height: 28px;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
